import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import {
  WorksheetImagesAndRemarksSection,
  WorksheetResultsSection,
  WorksheetRootComponent,
  WorksheetTestedBySection,
} from 'Components/Worksheets/Core';
import { valueOrDefault } from 'Lib/Any';
import { pipe } from 'Lib/Hooks/Selectors';
import { useSelector } from 'react-redux';
import { PageSection, SectionGroup } from '../../../Layout';
import ids from '../../QestIds';
import {
  AsCompactionCwdSection,
  AsCompactionDataSection,
  AsCompactionEquipmentSection,
  AsCompactionMoistureContentDeterminationEquipmentSection,
  AsCompactionMoistureContentDeterminationGridSection,
  AsCuringSection,
  AsPreparationSection,
  AsResultsSection,
  AsTestFractionParticleDensitySection,
} from './Sections';

const qestIds = [ids.maximumDryDensity.AS_1289_5_1_1.rev2017, ids.maximumDryDensity.AS_1289_5_2_1.rev2017];

let Worksheet: WorksheetRootComponent = ({ createWorksheetSelector }) => {
  const materialNotSuitableDueToOversize = useSelector(
    pipe(createWorksheetSelector!('Preparation.ScreeningASTM.MaterialNotSuitableDueToOversize'), valueOrDefault(false))
  );

  return (
    <>
      <PageSection heading="Preparation">
        <AsPreparationSection />
      </PageSection>
      {!materialNotSuitableDueToOversize && (
        <>
          <PageSection heading="Curing">
            <AsCuringSection />
          </PageSection>

          <PageSection heading="Compaction">
            <AsCompactionEquipmentSection />
            <SectionGroup heading="Compaction Data">
              <AsCompactionCwdSection />
              <AsCompactionDataSection />
            </SectionGroup>
            <SectionGroup heading="Moisture Content Determination">
              <AsCompactionMoistureContentDeterminationEquipmentSection />
              <AsCompactionMoistureContentDeterminationGridSection />
            </SectionGroup>
          </PageSection>

          <PageSection heading="Test Fraction Particle Density">
            <AsTestFractionParticleDensitySection />
          </PageSection>
        </>
      )}
      <PageSection>
        <WorksheetTestedBySection />
      </PageSection>

      <WorksheetResultsSection heading="Results">
        <AsResultsSection />
      </WorksheetResultsSection>

      <PageSection heading="Images and Remarks">
        <WorksheetImagesAndRemarksSection />
      </PageSection>
    </>
  );
};

Worksheet.qestIds = qestIds;
const AsMaximumDryDensityWorksheet = withInjectedProps(Worksheet);

export { AsMaximumDryDensityWorksheet };
export default AsMaximumDryDensityWorksheet;
